import React, { Component, Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import airplane_icon from 'components/assets/img/icons/airplane.svg';
import moment from 'moment';
import TimetableHelper from 'components/components/booking/Map/utils/TimetableHelper';
import { DIRECTION_FLIGHT, DIRECTION_ARRIVE, DEPARTURE, RETURN }
  from 'components/components/booking/utils/FlightConstants';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FlightHelper from 'components/common/helpers/FlightHelper';
import T from 'components/common/translations/Translate';
import TransHelper from 'components/common/translations/TransHelper';
import OverrideUserData from '../booking/Summary/components/OverrideUserData';

class SummaryFlights extends Component {

  trans = (key, prefix = "content.dashboard") => {
    return TransHelper.translate(this.props.locale, prefix + '.' + key);
  }

  getFlightRowContent = (flightObject, address, localFlightType) => {
    const { flightType } = this.props;
    if (flightObject === null) {
      return null;
    }
    var correctFlightType = flightType ? flightType : localFlightType;
    var flightHelper = new FlightHelper(flightObject, this.props.locale, correctFlightType);
    var busStopTime = '';
    var timetableHelper = new TimetableHelper(flightObject, address);
    var data = timetableHelper.getTimetableInfo();
    if (data) {
      busStopTime = data.busStopTime;
    }

    return (
      <li className="list-summary__item">
        <div className="list-summary__header">
          <div className="text-bold">{flightHelper.getLabel()}</div>
          <div>{flightHelper.getFlightDate()}</div>
        </div>

        <div className="list-summary__desc">
          <div>{flightHelper.getFlightTimeFrom()} {flightHelper.getFrom()}</div>
          <div><img src={airplane_icon} alt="icone airplane" /></div>
          <div>{flightHelper.getFlightTimeTo()} {flightHelper.getTo()}</div>
        </div>
        {
          address.phrase !== null &&
          <div className='list-summary__address'>
            <p>
              <FontAwesomeIcon
                icon={['fas', 'map-marker-alt']}
                color="#ccc"
              /> {timetableHelper.getRouteAsText()}
            </p>
          </div>
        }
      </li>
    );
  }

  timePartial(flightTime, direction, renderOnlyDirection) {
    if (direction === renderOnlyDirection) {
      return (
        <div className="list-flights__time">{flightTime}</div>
      );
    } else {
      return null;
    }
  }

  render() {
    const { differentReturnAddress, departureFlight, returnFlight,
      departureAddress, returnAddress, userNameOverride, userPhoneOverride } = this.props;
    var objectAddressReturn = null;
    if (returnFlight && !differentReturnAddress) {
      objectAddressReturn = departureAddress;
    } else {
      objectAddressReturn = returnAddress;
    }

    var ulClass = classNames(
      'list-summary',
      { 'list-summary--cell': this.props.isDashboard }
    );
    return (
      <ul className={ulClass}>
        {this.getFlightRowContent(departureFlight, departureAddress, DEPARTURE)}
        {this.getFlightRowContent(returnFlight, objectAddressReturn, RETURN)}
        <li className="list-summary__item list-summary__item--adults">
          <p>
            <FontAwesomeIcon
              icon={['fas', 'users']}
              color="#ccc"
            />
            <span className="list-summmary__label">{this.trans('adults', 'content.common')}:{' '}</span>
            <span style={{ marginRight: '20px' }}>{this.props.adultsNumber}</span>{' '}

            <span className="list-summmary__label">{this.trans('kids', 'content.common')}:</span>{' '}
            <span style={{ marginRight: '20px' }}>{this.props.childrenNumber}</span>

            <span className="list-summmary__label">{this.trans('students', 'content.common')}:</span>{' '}
            <span>{this.props.studentsNumber}</span>
          </p>
        </li>
        {!this.props.isDashboard &&
          <li className="list-summary__item list-summary__item--override-data">
            <OverrideUserData />
          </li>
        }

        {this.props.isDashboard &&
          <li className="list-summary__item list-summary__item--price">
            <FontAwesomeIcon
              icon={['fas', 'credit-card']}
              color="#ccc"
            />
            <span className="list-summmary__label">
              {this.trans('price', 'content.common')}:
            </span>
            {' '}
            {parseFloat(this.props.price)}
            {' '}
            <span className="currency">
              {this.trans('currency', 'content.common')}
            </span>
            {' '}

            {this.props.paymentToDriver
              ?
              (<em>({this.trans('payToDriver')})</em>)
              :
              (<em>({this.trans('payWithCard')})</em>)
            }
          </li>
        }
      </ul>
    );
  }
}

export default SummaryFlights;

SummaryFlights.propTypes = {
  adultsNumber: PropTypes.number,
  childrenNumber: PropTypes.number,
  studentsNumber: PropTypes.number,
  departureFlight: PropTypes.object,
  returnFlight: PropTypes.object,
  returnAddress: PropTypes.object,
  departureAddress: PropTypes.object,
  differentReturnAddress: PropTypes.bool,
};
